import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/less/common.less'
import '@/assets/less/font.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueQuillEditor from 'vue-quill-editor'
// 判读只能输入数字且限制最大最小
import onlyNumber from '@/directive'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import store from './store'
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.use(onlyNumber)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (!localStorage.getItem('userName') && to.meta.currentAuth) {
    localStorage.setItem('currentPath', to.fullPath)
    next()
  } else {
    next()
  }
})
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js